import React from "react";

import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";

import { IconLink } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type HelpButtonProps = {
  url: string;
};

export const HelpButton: React.FC<HelpButtonProps> = ({ url }) => {
  return (
    <Tooltip placement="top" title="View documentation">
      <IconLink
        aria-label="View documentation"
        href={url}
        icon={faQuestionCircle}
        openInNewTab
        size="xs"
      />
    </Tooltip>
  );
};
